import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, DropDownData, deleteData, initializeFilterData } from '../CommonComponents/CustomHooks';
import { handleDownloadExcel } from '../CommonComponents/ExportData';
import { FormButton, InputBox, SelectInputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const SMSSenderIdMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [formData, setFormData] = useState({
        smsSenderIDMasterID: '',
        serviceProviderID: '',
        senderID: '',
        isActive: true
    });
    const GetServiceProviderCode = DropDownData('GetServiceProvider')
    const getSMSSenderIdMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig,
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/GeneralSetting/ShowSMSSenderIDMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        }
        if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData({
            smsSenderIDMasterID: '',
            serviceProviderID: '',
            senderID: '',
            isActive: true
        });
        filterData.SearchText = '';
        setSortConfig({ SortColumn: null, SortOrder: null })
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/GeneralSetting/InsertUpdateSMSSenderIDMaster`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/GeneralSetting/EditSMSSenderIDMaster`, { smsSenderIDMasterID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setFormData((pre) => ({
                ...pre, ...editData
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/GeneralSetting/DeleteSMSSenderIDMaster`, {
            smsSenderIDMasterID
                : id
        }, getSMSSenderIdMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleChange1 = (event, value) => {
        getSMSSenderIdMasterData(value);
    };

    useEffect(() => {
        getSMSSenderIdMasterData()
        document.title = 'SMS SenderID Master'
        inputrefs.current['txtServiceProvider'].focus()
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'SMS SenderID Master'} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <SelectInputBox
                                id="txtServiceProvider"
                                value={formData.serviceProviderID}
                                label='Service Provider'
                                required={true}
                                onChange={(e) => setFormData({ ...formData, serviceProviderID: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtSenderID'].focus()
                                    }
                                }}
                            >
                                <option value=''>--Please Select--</option>
                                {GetServiceProviderCode?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.code}>{item.name}</option>
                                )}
                            </SelectInputBox>
                            <InputBox
                                id="txtSenderID"
                                type="text"
                                label='Sender ID'
                                required={true}
                                placeholder="Sender ID"
                                maxLength='50'
                                value={formData.senderID}
                                onChange={(e) => setFormData({ ...formData, senderID: e.target.value })}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtActive'].focus()
                                    }
                                }}
                            />
                            <Switch
                                inputrefs={inputrefs}
                                label='Active'
                                checked={formData.isActive}
                                id='txtActive'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    };
                                }}
                                onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                            />
                        </div>
                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleExport={() => handleDownloadExcel(`/api/GeneralSetting/ShowSMSSenderIDMaster`, filterData, 'SMS SenderID Master')}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>
            <Table
                handleEdit={handleEditData}
                handleDelete={handleDelete}
                loading={isLoading}
                PageName={'SMSSenderIDMaster'}
                handleFilter={() => {
                    getSMSSenderIdMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default SMSSenderIdMaster;